import { Text, Checkbox as VuiCheckbox } from '@village/ui';
import styled from 'styled-components';
import { device } from 'utils/device';

const Container = styled.div`
    display: grid;
    gap: 2.5rem;

    @media ${device.minLaptop} {
        gap: 2.5rem;
        grid-template-columns: 1.4fr 1fr;
    }

    @media ${device.minLaptopL} {
        gap: 6.25rem;
        margin: 0 auto;
        max-width: 1344px;
    }
`;

const PageTitle = styled(Text)`
    margin-bottom: 2.5rem;
`;

const AppointmentDetailsCardContainer = styled.div`
    @media ${device.maxLaptopL} {
        padding: 0 1.25rem;
    }
`;

const FormContainer = styled.div`
    display: grid;
    row-gap: 1.5rem;
    margin: 1.5rem 0;
`;

const Checkbox = styled(VuiCheckbox)`
    color: ${({ theme }) => theme.vui.colors.text.grayDefault};
`;

const ConfirmationButtonContainer = styled.div`
    margin: 3.75rem auto 0;
    max-width: 30rem;

    @media ${device.maxTablet} {
        margin: 2.25rem auto 0;
    }
`;

export { Container, PageTitle, AppointmentDetailsCardContainer, FormContainer, Checkbox, ConfirmationButtonContainer };
